module.exports = __webpack_public_path__ + "img/icon-pedidos-recogida.bf6bc130.svg";